var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cube-swipe"},[_vm._t("default",function(){return [_c('transition-group',{attrs:{"name":"cube-swipe","tag":"ul"}},_vm._l((_vm.data),function(item,index){return _c('li',{key:item.item.value},[_c('cube-swipe-item',{attrs:{"btns":item.btns,"item":item.item,"index":index,"auto-shrink":_vm.autoShrink}})],1)}),0)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }